import React from 'react'
import style from './style.module.scss'
import chessLocation from '@assets/images/chess/location.svg'
import MyImage from '@shared/components/myImage'
import title from '@assets/images/hil/logo.png'

function HockeyHeader() {
  return (
    <header className={style.chessHeader}>
      <div className={style.info}>
        <div className={style.teamAndPlayers}>
          <div>
            <h2>12</h2>
            <p>Teams</p>
          </div>
          <div>
            <h2>288</h2>
            <p>Players</p>
          </div>
        </div>
        <div className={style.teamAndPlayers}>
          <div>
            <h2>2</h2>
            <p>Venues</p>
          </div>
          <div>
            <h2>57</h2>
            <p>Matches</p>
          </div>
        </div>
      </div>
      <div className={style.mainTitle}>
        <div className="d-flex gap-4 align-items-center">
          {/* <div>
            <MyImage src={chessHeader} height={118} width={58} />
          </div> */}
          <div className="d-flex flex-column justify-content-start align-items-start gap-4">
            <MyImage src={title} alt="Hockey Title" />
            {/* <MyImage src={subTitle} /> */}
          </div>
        </div>
        <div className={style.location}>
          <MyImage src={chessLocation} alt="Chess Location" />
          India
        </div>
      </div>
      <div className={`${style.date} d-md-flex d-none`}>
        <p>28 Dec - 1 Feb 2025</p>
      </div>
      <div className={`d-md-none d-flex mt-4 ${style.mwebInfo}`}>
        <div>
          <h2>12</h2>
          <p>Teams</p>
        </div>

        <div>
          <h2>288</h2>
          <p>Players</p>
        </div>
        <div>
          <h2>2</h2>
          <p>Venues</p>
        </div>
        <div>
          <h2>57</h2>
          <p>Matches</p>
        </div>
      </div>
      <div className={`${style.date} d-md-none mt-4`}>
        <p>28 Dec - 1 Feb 2025</p>
      </div>
    </header>
  )
}

export default HockeyHeader
